import { Card, Col } from 'reactstrap'
import { CalendarBootstrap } from '../../../../../Utils/Constants'
import BootstrapCalendarBody from './BootstrapCalendarBody'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const BootstrapCalendar = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={CalendarBootstrap} />
        <BootstrapCalendarBody/>
      </Card>
    </Col>
  )
}

export default BootstrapCalendar